import React from "react";
import translate from "../i18n/Translator";
import CompletePaymentPopup, { DefaultCompletePaymentPopupProps } from "./CompletePaymentPopup";

export default function ConciliatePaymentPopup(props: DefaultCompletePaymentPopupProps) {
    return (
        <CompletePaymentPopup approved
            title={translate("payments.conciliate.title")}
            content={translate("payments.conciliate.text")}
            button="primary" {...props} />
    );
}